import React from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import imgPic from '../../assets/img/integral_card_pic.png'
import imgStar from '../../assets/img/integral_card_star.png'
import { withTranslation } from 'react-i18next'
@withTranslation()
@connect(state => {
  return {
    store: state.integralList.userData
  }
})
@withRouter
class IntegralCardV2 extends React.PureComponent {
  render () {
    const {t} = this.props
    const { integral } = this.props.store
    return <div className={'integral-card-v2 integral-card-v2--xiniu'}>
      <div className={'integral-card-v2__left'}>
        <div className={'integral-card-v2__title'}>
          <img src={imgStar} alt=''/>&nbsp;
          <span>{t('integral.card_title')}</span>
        </div>
        <div className={'integral-card-v2__value'}>
          {Number(integral) >= 0 ? integral : '-'}
        </div>
        <div className={'integral-card-v2__btn'} onClick={this.goToDetails}>
          {t('integral.card_sub')} >
        </div>
      </div>
      <div className={'integral-card-v2__right'}>
        <img src={imgPic} alt=''/>
      </div>
    </div>
  }
  goToDetails = () => {
    this.props.history.push(window.PATH.INTEGRAL_DETAILS)
  }
}

export default IntegralCardV2
